import React from 'react'

export default function ElementorWrap(props) {
	return <div className="elementor elementor-560">{props.children}</div>
}
